import React, { useEffect, useRef } from 'react';
import useDuplicateImagesStore from '@/components/admin/ImageManager/ImageMergeModal/useDuplicateImagesStore';

interface SelectAllCheckboxProps {
  imageIds: number[];
}

const SelectAllCheckbox = ({ imageIds }: SelectAllCheckboxProps) => {
  const ref = useRef<HTMLInputElement>();
  const checkedImageIds = useDuplicateImagesStore(state => state.checkedImageIds);
  const populateCheckedImages = useDuplicateImagesStore(state => state.populateCheckedImages);
  const resetCheckedImages = useDuplicateImagesStore(state => state.resetCheckedImages);

  useEffect(() => {
    if (!ref.current) return;
    if (checkedImageIds.size === 1) return;
    if (checkedImageIds.size === imageIds.length) return;

    ref.current.indeterminate = true;
  }, [checkedImageIds.size, ref.current]);

  const handleChange = () => {
    if (checkedImageIds.size === imageIds.length) {
      resetCheckedImages();
      return;
    }

    populateCheckedImages(imageIds);
  };

  return (
    <input
      ref={ref}
      checked={checkedImageIds.size === imageIds.length}
      id="dup-image-select-all"
      type="checkbox"
      onChange={handleChange}
    />
  );
};

export default SelectAllCheckbox;
